var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditLogActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 4.41146C0.25 2.01822 2.1901 0.078125 4.58333 0.078125H15.4167C17.8099 0.078125 19.75 2.01822 19.75 4.41146V11.9948H16.5C14.1068 11.9948 12.1667 13.9349 12.1667 16.3281V19.5781H4.58333C2.1901 19.5781 0.25 17.638 0.25 15.2448V4.41146ZM5.66667 6.57812C5.66667 5.97982 6.1517 5.49479 6.75 5.49479H13.25C13.8483 5.49479 14.3333 5.97982 14.3333 6.57812C14.3333 7.17643 13.8483 7.66146 13.25 7.66146H6.75C6.1517 7.66146 5.66667 7.17643 5.66667 6.57812ZM6.75 9.82812C6.1517 9.82812 5.66667 10.3131 5.66667 10.9115C5.66667 11.5098 6.1517 11.9948 6.75 11.9948H8.91667C9.51499 11.9948 10 11.5098 10 10.9115C10 10.3131 9.51499 9.82812 8.91667 9.82812H6.75Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLogActive);
export default __webpack_public_path__ + "static/media/audit-log-active.5efc97378b33f06eed6ce60bb77101e7.svg";
export { ForwardRef as ReactComponent };